import { useNavigate } from 'react-router-dom';
import { T } from '@design/index';
import { card, VerifiedBadge, SectionTitle, WebEntryLayout } from './entryHelpers';
import { patientAuthFlow } from '../../auth/patientAuthFlow';

export default function VerificationUpdateRequiredScreen() {
  const navigate = useNavigate();
  const state = patientAuthFlow.getState();

  return (
    <WebEntryLayout>
    <div style={{ display: 'flex', flexDirection: 'column', fontFamily: T.font, flex: 1 }}>
      {/* Header */}
      <div style={{ padding: '12px 16px', background: T.white, borderBottom: `1px solid ${T.border}` }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: T.text }}>NeoHealthCard ID Status</div>
        <div style={{ fontSize: 9, color: T.textSec }}>Update Required</div>
      </div>

      <div style={{ flex: 1, overflowY: 'auto', padding: '14px 16px', display: 'flex', flexDirection: 'column', gap: 14 }}>
        {/* Status icon */}
        <div style={{ textAlign: 'center', padding: '10px 0' }}>
          <div style={{ width: 56, height: 56, borderRadius: 16, background: `${T.danger}12`, display: 'grid', placeItems: 'center', margin: '0 auto 12px' }}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={T.danger} strokeWidth="2.5" strokeLinecap="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="15" y1="9" x2="9" y2="15" />
              <line x1="9" y1="9" x2="15" y2="15" />
            </svg>
          </div>
          <div style={{ fontSize: 16, fontWeight: 800, color: T.text, marginBottom: 4 }}>Verification update required</div>
          {state.nhcId && (
            <div style={{ fontSize: 22, fontWeight: 800, color: T.navy, fontFamily: T.mono, letterSpacing: '0.06em', marginBottom: 4 }}>{state.nhcId}</div>
          )}
          <div style={{ display: 'inline-block', marginTop: 8 }}>
            <VerifiedBadge text="REJECTED" color={T.danger} />
          </div>
        </div>

        {/* Verification status card */}
        <div style={card()}>
          <SectionTitle text="Verification Status" />
          {[
            { label: 'Patient Identity', status: 'NEEDS UPDATE', color: T.danger, note: 'Some information needs correction' },
            { label: 'Registration Data', status: 'SUBMITTED', color: T.teal, note: 'Original submission received' },
            { label: 'NeoHealthCard ID Approval', status: 'REJECTED', color: T.danger, note: 'Cannot access dashboard until resolved' },
          ].map((v, i) => (
            <div key={i} style={{ padding: '8px 0', borderTop: i > 0 ? `1px solid ${T.borderLight || T.border}` : 'none' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: 10, fontWeight: 600, color: T.text }}>{v.label}</span>
                <VerifiedBadge text={v.status} color={v.color} />
              </div>
              <div style={{ fontSize: 8, color: T.textTer, marginTop: 2 }}>{v.note}</div>
            </div>
          ))}
        </div>

        {/* Reason placeholder */}
        <div style={{ padding: '10px 14px', background: `${T.danger}06`, borderRadius: 10, border: `1px solid ${T.danger}15` }}>
          <div style={{ fontSize: 10, fontWeight: 700, color: T.text, marginBottom: 4 }}>Reason for rejection</div>
          <div style={{ fontSize: 9, color: T.textSec, lineHeight: 1.7 }}>
            The verification team has flagged items that require update. Please review and update your registration information to proceed.
          </div>
        </div>

        {/* Update Registration */}
        <button
          onClick={() => navigate('/patient/register/basic')}
          style={{
            width: '100%',
            padding: '13px 0',
            borderRadius: 14,
            border: 'none',
            background: `linear-gradient(135deg, ${T.teal}, ${T.overlap})`,
            color: '#FFF',
            fontSize: 13,
            fontWeight: 700,
            fontFamily: T.font,
            cursor: 'pointer',
            textAlign: 'center',
            boxShadow: `0 4px 14px ${T.teal}40`,
          }}
        >
          Update Registration
        </button>

        {/* Return to Login */}
        <button
          onClick={() => {
            patientAuthFlow.resetToLogin();
            navigate('/patient/entry', { replace: true });
          }}
          style={{
            width: '100%',
            padding: '13px 0',
            borderRadius: 12,
            border: `1.5px solid ${T.teal}`,
            background: 'transparent',
            color: T.teal,
            fontSize: 13,
            fontWeight: 700,
            fontFamily: T.font,
            cursor: 'pointer',
            textAlign: 'center',
          }}
        >
          Return to Login
        </button>
      </div>
    </div>
    </WebEntryLayout>
  );
}
